import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import { useRef, useState } from 'react';

import { DndContext, DragOverlay, closestCenter } from '@dnd-kit/core';
import { SortableContext, arrayMove, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { v4 as uuidv4 } from 'uuid';

import arrow_left from '../../../assets/images/nav_icons/arrow-left.svg'
import ai_img from '../../../assets/images/questions/ai.svg'
import drag_img from '../../../assets/images/drag.svg'

import upload_img from '../../../assets/images/upload_white.svg'
import downalod_img from '../../../assets/images/download.svg'
import plus_img from '../../../assets/images/plus_white.svg'
import plus_blue from '../../../assets/images/plus.svg'
import excel_img from '../../../assets/images/questions/excel.svg'
import excel_template from '../../../assets/questions.xlsx'
import QuestionsUploader from '../../../components/_questions/QuestionsUploader';
import QuestionEditor from '../../../components/_questions/QuestionEditor';
import { setLoading } from '../../../services/global/globalSlice';
import { toast } from 'react-toastify';
import { fetchDownloadQuestions } from '../ExamApi';
import ConfirmModal from '../../../components/_modals/ConfirmModal';
import EditableInput from '../../../components/_form/EditableInput';
import AiEditor from '../../../components/_questions/AiEditor';
import { Form } from 'react-bootstrap';

export default function ExamQuestion (props) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()

    const [questionsSelection, setQuestionsSelection] = useState([])
    const [showUploadModal, setShopUploadModal] = useState(false)
    const [resetUpload, setResetUpload] = useState(false)
    const [forceUpload, setForceUpload] = useState(false)
    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "",
        closeCta: ""
    })
    const [draggedQuestion, setDraggedQuestion] = useState(null);
    const [showAiEditor, setShowAiEditor] = useState(false)
    const lastModuleRef =  useRef()


    const [showQuestionEditor, setShowQuestionEditor] = useState(false)
    const [selectedQuestion, setSelectedQuestion] = useState({
        module_id: null,
        question_id: null
    })

    const handleDragEnd = ({ active, over }) => {
        if (!over) return;

        const [sourceModuleIndex, sourceQuestionIndex] = findQuestionPosition(active.id);
        const [targetModuleIndex] = findQuestionPosition(over.id);
        console.log(sourceModuleIndex, sourceQuestionIndex, targetModuleIndex);
        

        // Se la domanda viene spostata nello stesso modulo
        if (sourceModuleIndex === targetModuleIndex) {
            const newQuestions = arrayMove(
            props.examData?.modules[sourceModuleIndex].questions,
            sourceQuestionIndex,
            props.examData?.modules[sourceModuleIndex]?.questions.findIndex(q => q.question_id === over.id)
            );

            updateModuleQuestions(sourceModuleIndex, newQuestions);
        } else {
            // Se la domanda viene spostata in un altro modulo
            const sourceQuestions = [...props.examData?.modules[sourceModuleIndex].questions];
            const [movedQuestion] = sourceQuestions.splice(sourceQuestionIndex, 1); // Rimuovi la domanda dal modulo sorgente

            const targetQuestions = [...props.examData?.modules[targetModuleIndex].questions];
            const targetIndex = props.examData?.modules[targetModuleIndex]?.questions.findIndex(q => q.question_id === over.id);
            targetQuestions.splice(targetIndex, 0, movedQuestion); // Aggiungi la domanda al modulo di destinazione

            updateModuleQuestions(sourceModuleIndex, sourceQuestions, targetModuleIndex, targetQuestions); // Aggiorna il modulo sorgente
            //updateModuleQuestions(targetModuleIndex, targetQuestions); // Aggiorna il modulo di destinazione
        }
        // Reset del question dragged
            setDraggedQuestion(null);
    };

    const findQuestionPosition = (questionId) => {
        for (let i = 0; i < props.examData?.modules.length; i++) {
        const questionIndex = props.examData?.modules[i].questions.findIndex(q => q.question_id === questionId);
        if (questionIndex !== -1) {
            return [i, questionIndex];
        }
        }
        return [null, null];
    };

    const updateModuleQuestions = (sourceModuleIndex, sourceNewQuestions, targetModuleIndex, targetQuestions) => {
        let _modules = structuredClone(props.examData?.modules)
        const newModules = [..._modules];
        newModules[sourceModuleIndex] = {
            ...newModules[sourceModuleIndex],
            questions: sourceNewQuestions,
        };
        newModules[targetModuleIndex] = {
            ...newModules[targetModuleIndex],
            questions: targetQuestions,
        };
        props.onExamDataChange({
            ...props.examData,
            modules: newModules
        })
    };

    const handleRenderQuestions = ( ) => {
        setShopUploadModal(false)
        props.reloadData()
    }

    const handleQuestionDataChange = (data) => {
        let _modules = structuredClone(props.examData?.modules)
        _modules[selectedQuestion.module_id].questions[selectedQuestion.question_id] = data
        props.onExamDataChange({
            ...props.examData,
            modules: _modules
        })
    }

    const handleUpdateModuleData = (e, name, index) => {
        let _modules = structuredClone(props.examData?.modules)
        _modules[index]={
            ..._modules[index],
            [name]: e.target.value
        }
        props.onExamDataChange({
            ...props.examData,
            modules: _modules
        })
    }


    const addQuestion = (module_id) =>{
        let _modules = structuredClone(props.examData?.modules || [])
        if(module_id !== null){
            _modules[module_id].questions = [
                ..._modules[module_id].questions || [],
                {
                    question_type: "base",
                    text: "",
                    answers: [],
                    isNew:true ,
                    question_id : `q-${uuidv4()}`
                }
            ]
        } else {
            _modules.push({
                module_name: "",
                description: "",
                questions: [{
                    question_type: "base",
                    text: "",
                    answers: [],
                    isNew:true,
                    question_id : `q-${uuidv4()}`
                }]
            })
            module_id = _modules.length - 1
        }
        const question_id = _modules[module_id].questions?.length - 1
        props.onExamDataChange({
            ...props.examData,
            modules: _modules
        }) 
        console.log(module_id, question_id);
        openQuestion(module_id, question_id)
    }

    const openQuestion = (module_id, question_id, question) => {
        console.log(module_id, question_id);
        
        setSelectedQuestion({
            module_id: module_id,
            question_id: question_id
        })
        setShowQuestionEditor(true)
    }

    const handleCloseQuestion = (module_id, question_id, question) => {
        setSelectedQuestion({
            module_id: null,
            question_id: null
        })
        setShowQuestionEditor(false)
    }

    const downloadQuestions = async () => {
        dispatch(setLoading(true))
        const response = await fetchDownloadQuestions(props.examData.exam_id);
        if (response.success) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `questions_exam_${props.examData.exam_id}_${new Date().toLocaleDateString("it-IT")}.xlsx`);
            document.body.appendChild(link);
            link.click();
            dispatch(setLoading(false))
        } else {
            toast.error(t.question.error_while_downloading)
            dispatch(setLoading(false))
        }
    }

    const closeConfirmModal = () =>{
        setConfirmModal({
            ...confirmModal,
            show:false
        })
    }

    const handleRemoveQuestion = (_,force = false) => {
        if(!force){
            setConfirmModal({
                ...confirmModal,
                show:true,
                title: t.question.delete_title,
                text: t.question.delete_text,
                onClose: ()=>closeConfirmModal(),
                onConfirm: ()=>handleRemoveQuestion(true,true),
                confirmCta: t.question.delete_cta,
                closeCta: t.modals.no_exit,
            })
        } else {
            let _modules = structuredClone(props.examData.modules)
            let _questions = _modules[selectedQuestion.module_id].questions
            if (selectedQuestion.question_id > -1) { 
                _questions.splice(selectedQuestion.question_id, 1); 
            }
            _modules[selectedQuestion.module_id] = {
                ..._modules[selectedQuestion.module_id],
                questions: _questions
            }
            if(_modules[selectedQuestion.module_id]?.questions?.length === 0)
                _modules.splice(selectedQuestion.module_id, 1); 
            props.onExamDataChange({
                ...props.examData,
                modules: _modules
            })
            closeConfirmModal()
            setShowQuestionEditor(false)
            setSelectedQuestion({
                question_id: null,
                module_id: null,
            })
        }
    }

    function handleDragStart(event) {
        console.log(event.active.id);
        
        setDraggedQuestion(event.active.id);
    }

    const backToEditor = () => {
        setForceUpload(false)
        setResetUpload(false)
        if(!props.examData?.modules || props.examData?.modules?.length === 0){
            let _modules = structuredClone(props.examData?.modules || [])
            _modules.push({
                module_name: "",
                description: "",
                questions: []
            })
            props.onExamDataChange({
                ...props.examData,
                modules: _modules
            })   
        }
        
    }

    const handleRemoveModule = (module_id,force = false) => {
        if(!force){
            setConfirmModal({
                ...confirmModal,
                show:true,
                title: t.exam.delete_module_title,
                text: t.exam.delete_module_text,
                onClose: ()=>closeConfirmModal(),
                onConfirm: ()=>handleRemoveModule(module_id,true),
                confirmCta: t.question.delete_cta,
                closeCta: t.modals.exit,
            })
        } else {
            
            let _modules = structuredClone(props.examData.modules)
            if(module_id !== null){
                _modules.splice(module_id, 1); 
                props.onExamDataChange({
                    ...props.examData,
                    modules: _modules
                })
                closeConfirmModal()
                setSelectedQuestion({
                    question_id: null,
                    module_id: null,
                })
            }
            
        }
    }

    const findModuleAndQuestionIndex = (question_id) => {
        let module_index = -1
        let question_index = -1
        props.examData?.modules?.forEach((module,index)=>{
            module?.questions?.forEach((question,q_index)=>{
                if(question.question_id === question_id){
                    module_index = index
                    question_index = q_index
                }
            })
        })
        console.log({question_index: question_index, module_index: module_index});
        
        return {question_index: question_index, module_index: module_index}
    }

    const handleSaveQuestion = () => {
        const _modules = structuredClone(props.examData?.modules)
        const _question = _modules[selectedQuestion.module_id].questions[selectedQuestion.question_id]
        if(!_question.text){
            toast.error(t.question.required_text)
            return;
        }
        if(_question.question_type !== "block"){
            const min_answers = _question.question_type === "fill" ? 1 : 2
            if(_question.answers?.length < min_answers){
                toast.error(_question.question_type === "fill" ? t.question.min_answers_fill : t.question.min_answers)
                return;
            }
            const correct_answers = _question.answers.filter(a=>a.is_correct_answer === true)
            if(_question.question_type === "base" && correct_answers.length > 1){
                toast.error(t.question.only_one_correct)
                return;
            }
            if(_question.question_type !== "survey" && correct_answers.length === 0){
                toast.error(t.question.at_least_one_correct)
                return;
            }   
        } else {
            if(_question.blocks?.length < 1){
                toast.error(t.question.min_block)
                return;
            }
            let block = false
            _question.blocks?.forEach(block => {
                if(!block.text){
                    toast.error(t.question.required_text_block)
                    block = true
                }
                const correct_answers = block.answers.filter(a=>a.is_correct_answer === true)
                if(correct_answers.length > 1){
                    toast.error(t.question.only_one_correct)
                    block = true
                }
            });
            if(block)
                return;
        }
        setSelectedQuestion({
            module_id: null,
            question_id: null
        })
        setShowQuestionEditor(false)
    }

    //AI
    const openAiEditor = () => {
        setShowAiEditor(true)
    }

    const closeAiEditor = () => {
        setShowAiEditor(false)
    }

    const handleAiCreation = () => {
        props.reloadData();
        setShowAiEditor(false);
        setTimeout(()=>{
            lastModuleRef?.current?.scrollIntoView({behavior: "smooth"})
        },2000)
    }

    return (
        <div className=''>
            { !props.examData?.modules || props.examData?.modules?.length === 0 || resetUpload ?
                <>
                    <div className="info_card">
                        <h2>{t.question.question_adding}</h2>
                        <div className='d-flex mt-3'>
                            <button onClick={()=>setShopUploadModal(true)}>
                                {t.question.excel_import}
                                <img src={upload_img} className='ms-1' alt=''/>
                            </button>
                            <button className='ms-2' onClick={backToEditor}>
                                {t.question.create_question}
                                <img src={plus_img} className='ms-1' alt=''/>
                            </button>
                        </div>
                    </div> 
                    
                    <div className="info_card">
                        <h2>{t.question.need_help}</h2>
                        <p>{t.question.need_help_text}</p>
                        <div className='d-flex justify-content-between'>
                            <div className="info_card">
                                <h3><img src={excel_img} className='me-1' alt=''/>{t.question.template_excel}</h3>
                                <p>{t.question.template_excel_text}</p>
                                <a href={excel_template} download>
                                <button className='secondary'>
                                    {t.question.download_template}
                                    <img src={downalod_img} className='ms-1' alt=''/>
                                </button>
                                </a>
                            </div>  
                        </div>
                    </div> 
                    <QuestionsUploader show={showUploadModal} onClose={()=>setShopUploadModal(false)} endpoint={`/admin/add_new_questions_from_excel?exam_id=${props.examData.exam_id}`} onUploadComplete={handleRenderQuestions} />
                </>
            : <div className='d-flex justify-content-between align-items-center'> 
                <a href='#' onClick={()=>setResetUpload(true)}>
                    <img src={arrow_left} alt=''/>
                    {t.question.back_to_upload}
                </a>
                <a href='#' onClick={downloadQuestions}>
                    {t.question.download_questions}
                </a>
            </div> }

            { props.examData?.modules && props.examData?.modules?.length > 0 && !resetUpload ?
            <div>
                <div className='d-flex mt-2 align-items-center exams-step-5'>
                    <div className='questions_module new_module  col-7' id={`module_default}`}>
                        <div className='d-flex justify-content-between'>   
                            <p className='mb-0'>{t.question.new_module}</p> 
                            <a href={`#module_default`} onClick={()=>addQuestion(null)}>
                                <u>{t.question.add_question}</u>
                                <img src={plus_blue} className='ms-1' alt=''/>
                            </a>
                        </div>
                    </div>
                    <div className='questions_module new_module ai_module ms-2 col-5' id={`module_default}`}>
                        <div className='d-flex justify-content-between align-items-center ' >   
                            <p className='mb-0'>{t.question.generate_with_ai}</p> 
                            <button className='bg-white text-tf mb-0' onClick={openAiEditor}><img src={ai_img} alt='' style={{maxWidth:"24px"}}  /> Crea</button>
                        </div>
                        <AiEditor show={showAiEditor} examData={props.examData} examId={props.examData.exam_id} onClose={closeAiEditor} onUpdate={handleAiCreation} />
                    </div>
                </div>
                <DndContext
                    collisionDetection={closestCenter}
                    onDragStart={handleDragStart}
                    onDragEnd={handleDragEnd}
                    >
                    {props.examData?.modules.map((module, index) => (
                        <Module position={index === props?.examData?.modules?.length -1  ? lastModuleRef : null} key={index} modules={props.examData?.modules} module={module} moduleIndex={index} t={t} openQuestion={openQuestion} handleUpdateModuleData={handleUpdateModuleData} handleRemoveModule={handleRemoveModule} addQuestion={addQuestion} draggedQuestionId={draggedQuestion}/>
                    ))}
                    <DragOverlay>
                    {draggedQuestion ? (
                        <div style={{ background: '#f0f0f0', padding: '8px', borderRadius: '4px', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}>
                            {findModuleAndQuestionIndex(draggedQuestion).question_index !== -1 && (
                                <>
                                    <strong>{t.question.question} {findModuleAndQuestionIndex(draggedQuestion).question_index + 1}</strong>
                                    <p>{props.examData?.modules[findModuleAndQuestionIndex(draggedQuestion).module_index]?.questions[findModuleAndQuestionIndex(draggedQuestion).question_index].text}</p>
                                </>
                            )}
                        </div>
                    ) : null}   
                </DragOverlay>
                </DndContext>
                <QuestionEditor 
                    show={showQuestionEditor} 
                    closeQuestion={handleCloseQuestion}
                    handleDataChange={handleQuestionDataChange}
                    updateQuestions={handleSaveQuestion}
                    removeQuestion={handleRemoveQuestion}
                    questionData={selectedQuestion.module_id !== null && selectedQuestion.question_id !== null ? props.examData?.modules[selectedQuestion.module_id]?.questions[selectedQuestion.question_id] : null} 
                />
            </div> : null }
            <ConfirmModal props={confirmModal}/>
        </div>
        
    )
}


// Componente per visualizzare una singola domanda
function QuestionItem({ question, openQuestion, t, module_index, index }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: question.question_id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: '8px',
    margin: '4px',
    borderRadius: '4px',
    cursor: 'grab',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} className='module_question d-flex align-items-center justify-content-between' onDoubleClick={()=>openQuestion(module_index,index,question)}>
        <div className='col-11 d-flex align-items-center'>
            <span
                {...listeners}  
                className="drag-handle" 
                style={{ cursor: 'move', padding: '5px', marginRight: '10px' }}
                >
                <img src={drag_img} alt=''/>
            </span>
            <input type='checkbox' className='input-check'/>
            <span className='ms-2 mb-0'><strong style={{textWrap:"nowrap"}}>{t.question.question} {index+1}</strong></span>
            <p className='ms-2 mb-0'>{question.text}</p>
        </div>
        {
            question?.ai_generated &&
                <img src={ai_img} style={{maxWidth:"20px"}} alt='' title={t.ai_assistant.ai_generated}/>
        }
    </div>
  );
}

// Componente per gestire una lista di domande
function Module({ modules, module, moduleIndex, onMoveQuestion, position, openQuestion, addQuestion, handleUpdateModuleData, handleRemoveModule, t, draggedQuestionId }) {
  return (
    <div ref={position}  className='questions_module' id={`module_${moduleIndex}`}>
        <div className='d-flex justify-content-between'>   
            
            <div className='d-flex align-items-center'><EditableInput value={module.module_name || (modules.length > 1 ? t.question.new_module : t.question.all_the_questions)} onChange={(e)=>handleUpdateModuleData(e,'module_name',moduleIndex)} style={{fontSize:"24px",fontWeight:"700"}} />  <span style={{fontSize:'20px'}} className='ms-2'>({module?.questions?.length})</span></div> 
            <a href={`#module_${moduleIndex}`} onClick={()=>addQuestion(moduleIndex)}>
                <u>{t.question.add_question}</u>
                <img src={plus_blue} className='ms-1' alt=''/>
            </a>
        </div>
        <div className='module_questions'>
        <SortableContext items={module.questions.map(q => q.question_id)}>
            {module.questions.map((question, index) => (
                <QuestionItem key={question.question_id} index={index} module_index={moduleIndex} question={question} openQuestion={openQuestion} t={t} isDragging={draggedQuestionId === question.question_id}/>
            ))}
        </SortableContext>
        </div>
        <div className='col-12 mt-3'>
            <div className='d-flex justify-content-between align-items-center'>
                <span className='text-danger pointer' onClick={()=>handleRemoveModule(moduleIndex)}>{t.exam.delete_module}</span>
                <Form.Group controlId="description" className='ms-2 d-flex align-items-center'>
                    <Form.Label>{t.exam.questions_to_extract}</Form.Label>
                    <Form.Control className='minw-0 ms-2' type="number" value={module.num_questions_per_module || ''} name="num_questions_per_module" onChange={(e)=>handleUpdateModuleData(e,'num_questions_per_module',moduleIndex)} />
                </Form.Group>
            </div>
        </div>
    </div>
  );
}